import 'react-app-polyfill/ie11'
import 'react-app-polyfill/stable'
import 'intl-pluralrules'
import React, { Suspense } from 'react'
import ReactDOM from 'react-dom'
import './styles/index.scss'
import AppRouter from './AppRouter'
import './i18n'
import { Spinner } from '@digicert/dcone-common-ui'

ReactDOM.render(
  <Suspense fallback={<Spinner />}>
    <AppRouter/>
  </Suspense>,
  document.getElementById('root')
);
